import React, { useState, useEffect } from 'react';
import { Card } from './Card';

export const ShortcutMenu = () => {
  const [activeSection, setActiveSection] = useState('contact');

  const steps = [
    { id: 'contact', label: 'Details', num: 1 },
    { id: 'transactions', label: 'Transactions', num: 2 },
    { id: 'spend', label: 'Spend', num: 3 },
    { id: 'assets', label: 'Assets', num: 4 },
    { id: 'lifecycle', label: 'Lifecycle & Mix', num: 5 },
    { id: 'submit-section', label: 'Submit', num: 6 },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const current = steps.reduce((acc, step) => {
        const el = document.getElementById(step.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          // Trigger when the section reaches the upper third of the viewport
          if (rect.top <= window.innerHeight / 3) {
            return step.id;
          }
        }
        return acc;
      }, steps[0].id);
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initialize on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 120; // Account for the sticky menu height
      const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const activeIndex = steps.findIndex(s => s.id === activeSection);

  return (
    <div className="sticky top-4 z-50 mb-8 w-full transition-all">
      <Card className="px-3 py-4 sm:px-8 sm:py-5 shadow-sm border-brand-border bg-white/95 backdrop-blur-md">
        <div className="relative flex justify-between items-center w-full">
          {/* Continuous Connecting Line */}
          <div className="absolute top-4 left-[5%] right-[5%] h-[2px] bg-brand-border/60 -z-10" />

          {steps.map((step, index) => {
            const isActive = activeIndex >= index;
            const isCurrent = activeSection === step.id;

            return (
              <button
                key={step.id}
                onClick={() => scrollTo(step.id)}
                className="flex flex-col items-center gap-2 group outline-none"
              >
                <div 
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 border-2
                  ${isCurrent
                    ? 'bg-brand-accent text-white border-brand-accent shadow-md scale-110'
                    : isActive
                      ? 'bg-brand-text text-white border-brand-text'
                      : 'bg-white text-brand-muted border-brand-border'
                  }`}
                >
                  {step.num}
                </div>
                <span 
                  className={`text-[10px] sm:text-xs font-semibold tracking-wide transition-colors hidden sm:block
                  ${isCurrent ? 'text-brand-text' : isActive ? 'text-brand-text' : 'text-brand-muted group-hover:text-brand-text'}`}
                >
                  {step.label}
                </span>
              </button>
            );
          })}
        </div>
      </Card>
    </div>
  );
};